module.exports = __webpack_public_path__ + "static/media/bird-chirping.a2a875f0.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/online-assets/sounds/bird-chirping.mp3
// module id = 2125
// module chunks = 0